import type { ProcessModelLibraryEntry } from './types'

export const processModelLibrary: ProcessModelLibraryEntry[] = [
  {
    id: 'patient-flow',
    name: 'Patient Flow',
    description: 'Hospital patient admission to discharge · 1,280 total traces',
    graph: {
      nodes: [
        { id: 'start', label: 'Patient created', count: '1.280', type: 'start', layer: 0, col: 0 },
        { id: 'task-172', label: 'Task added', count: '172', type: 'activity', layer: 1, col: 0 },
        { id: 'assign-1108', label: 'Assign bed', count: '1.108', type: 'activity', layer: 1, col: 1 },
        { id: 'assign-208', label: 'Assign bed', count: '208', type: 'activity', layer: 2, col: 0 },
        { id: 'task-900', label: 'Task added', count: '900', type: 'activity', layer: 2, col: 1 },
        { id: 'task-done', label: 'Task done', count: '900', type: 'activity', layer: 2, col: 2, activityIcon: 'check' },
        { id: 'unassigned', label: 'Unassigned', count: '1.108', type: 'activity', layer: 3, col: 0 },
        { id: 'end', label: 'Patient discharged', count: '1.280', type: 'end', layer: 4, col: 0 },
      ],
      edges: [
        { from: 'start', to: 'assign-1108', label: '1.108', weight: 1108 },
        { from: 'start', to: 'task-172', label: '172', weight: 172 },
        { from: 'assign-1108', to: 'task-900', label: '900', weight: 900 },
        { from: 'assign-1108', to: 'assign-208', label: '208', weight: 208 },
        { from: 'task-172', to: 'assign-208', label: '172', weight: 172 },
        { from: 'task-900', to: 'unassigned', label: '900', weight: 900 },
        { from: 'task-900', to: 'task-done', label: '528', weight: 528 },
        { from: 'task-done', to: 'task-900', label: '528', weight: 528 },
        { from: 'assign-208', to: 'unassigned', label: '208', weight: 208 },
        { from: 'assign-208', to: 'end', label: '172', weight: 172 },
        { from: 'unassigned', to: 'end', label: '1.108', weight: 1108 },
      ],
      traces: [
        { name: 'Main path', nodes: ['start', 'assign-1108', 'task-900', 'unassigned', 'end'] },
        { name: 'Task loop ×1', nodes: ['start', 'assign-1108', 'task-900', 'task-done', 'task-900', 'unassigned', 'end'] },
        { name: 'Task loop ×2', nodes: ['start', 'assign-1108', 'task-900', 'task-done', 'task-900', 'task-done', 'task-900', 'unassigned', 'end'] },
        { name: 'Alt: Task added → Assign 208', nodes: ['start', 'task-172', 'assign-208', 'unassigned', 'end'] },
        { name: 'Alt: Assign bed → Assign 208', nodes: ['start', 'assign-1108', 'assign-208', 'unassigned', 'end'] },
        { name: 'Short: directly discharged', nodes: ['start', 'task-172', 'assign-208', 'end'] },
        { name: 'Short: Assign bed → discharged', nodes: ['start', 'assign-1108', 'assign-208', 'end'] },
      ],
    },
  },
  {
    id: 'order-fulfillment',
    name: 'Order Fulfillment',
    description: 'E-commerce order from placement to delivery · 3,440 traces',
    graph: {
      nodes: [
        { id: 'start', label: 'Order placed', count: '3.440', type: 'start', layer: 0, col: 0 },
        { id: 'payment', label: 'Payment check', count: '3.440', type: 'activity', layer: 1, col: 0 },
        { id: 'fraud', label: 'Fraud review', count: '412', type: 'activity', layer: 2, col: 0 },
        { id: 'pick', label: 'Pick & pack', count: '3.028', type: 'activity', layer: 2, col: 1 },
        { id: 'reject', label: 'Order rejected', count: '89', type: 'activity', layer: 3, col: 0 },
        { id: 'ship', label: 'Shipped', count: '3.351', type: 'activity', layer: 3, col: 1 },
        { id: 'return', label: 'Return initiated', count: '187', type: 'activity', layer: 4, col: 0 },
        { id: 'deliver', label: 'Delivered', count: '3.164', type: 'activity', layer: 4, col: 1 },
        { id: 'end', label: 'Order complete', count: '3.440', type: 'end', layer: 5, col: 0 },
      ],
      edges: [
        { from: 'start', to: 'payment', label: '3.440', weight: 3440 },
        { from: 'payment', to: 'fraud', label: '412', weight: 412 },
        { from: 'payment', to: 'pick', label: '3.028', weight: 3028 },
        { from: 'fraud', to: 'reject', label: '89', weight: 89 },
        { from: 'fraud', to: 'pick', label: '323', weight: 323 },
        { from: 'pick', to: 'ship', label: '3.351', weight: 3351 },
        { from: 'ship', to: 'deliver', label: '3.164', weight: 3164 },
        { from: 'ship', to: 'return', label: '187', weight: 187 },
        { from: 'return', to: 'pick', label: '142', weight: 142 },
        { from: 'deliver', to: 'end', label: '3.164', weight: 3164 },
        { from: 'reject', to: 'end', label: '89', weight: 89 },
        { from: 'return', to: 'end', label: '45', weight: 45 },
      ],
      traces: [
        { name: 'Happy path', nodes: ['start', 'payment', 'pick', 'ship', 'deliver', 'end'] },
        { name: 'Fraud review → cleared', nodes: ['start', 'payment', 'fraud', 'pick', 'ship', 'deliver', 'end'] },
        { name: 'Fraud review → rejected', nodes: ['start', 'payment', 'fraud', 'reject', 'end'] },
        { name: 'Return & reship', nodes: ['start', 'payment', 'pick', 'ship', 'return', 'pick', 'ship', 'deliver', 'end'] },
        { name: 'Return only', nodes: ['start', 'payment', 'pick', 'ship', 'return', 'end'] },
        { name: 'Fraud + return', nodes: ['start', 'payment', 'fraud', 'pick', 'ship', 'return', 'pick', 'ship', 'deliver', 'end'] },
      ],
    },
  },
  {
    id: 'software-deploy',
    name: 'Software Deployment',
    description: 'CI/CD pipeline from commit to production · 892 runs',
    graph: {
      nodes: [
        { id: 'start', label: 'Commit pushed', count: '892', type: 'start', layer: 0, col: 0 },
        { id: 'lint', label: 'Lint & format', count: '892', type: 'activity', layer: 1, col: 0 },
        { id: 'test', label: 'Unit tests', count: '851', type: 'activity', layer: 2, col: 0 },
        { id: 'build', label: 'Build artifact', count: '819', type: 'activity', layer: 3, col: 0 },
        { id: 'staging', label: 'Deploy staging', count: '819', type: 'activity', layer: 4, col: 0 },
        { id: 'e2e', label: 'E2E tests', count: '794', type: 'activity', layer: 5, col: 0 },
        { id: 'approve', label: 'Manual approval', count: '761', type: 'activity', layer: 5, col: 1 },
        { id: 'prod', label: 'Deploy prod', count: '761', type: 'activity', layer: 6, col: 0 },
        { id: 'rollback', label: 'Rollback', count: '58', type: 'activity', layer: 7, col: 0 },
        { id: 'end', label: 'Release complete', count: '892', type: 'end', layer: 8, col: 0 },
      ],
      edges: [
        { from: 'start', to: 'lint', label: '892', weight: 892 },
        { from: 'lint', to: 'test', label: '851', weight: 851 },
        { from: 'lint', to: 'end', label: '41', weight: 41 },
        { from: 'test', to: 'build', label: '819', weight: 819 },
        { from: 'test', to: 'end', label: '32', weight: 32 },
        { from: 'build', to: 'staging', label: '819', weight: 819 },
        { from: 'staging', to: 'e2e', label: '794', weight: 794 },
        { from: 'staging', to: 'approve', label: '25', weight: 25 },
        { from: 'e2e', to: 'approve', label: '761', weight: 761 },
        { from: 'e2e', to: 'end', label: '33', weight: 33 },
        { from: 'approve', to: 'prod', label: '761', weight: 761 },
        { from: 'prod', to: 'rollback', label: '58', weight: 58 },
        { from: 'prod', to: 'end', label: '703', weight: 703 },
        { from: 'rollback', to: 'staging', label: '31', weight: 31 },
        { from: 'rollback', to: 'end', label: '27', weight: 27 },
      ],
      traces: [
        { name: 'Green path', nodes: ['start', 'lint', 'test', 'build', 'staging', 'e2e', 'approve', 'prod', 'end'] },
        { name: 'Lint failure', nodes: ['start', 'lint', 'end'] },
        { name: 'Test failure', nodes: ['start', 'lint', 'test', 'end'] },
        { name: 'E2E failure', nodes: ['start', 'lint', 'test', 'build', 'staging', 'e2e', 'end'] },
        { name: 'Rollback & retry', nodes: ['start', 'lint', 'test', 'build', 'staging', 'e2e', 'approve', 'prod', 'rollback', 'staging', 'e2e', 'approve', 'prod', 'end'] },
        { name: 'Skip E2E (fast track)', nodes: ['start', 'lint', 'test', 'build', 'staging', 'approve', 'prod', 'end'] },
        { name: 'Rollback → abandon', nodes: ['start', 'lint', 'test', 'build', 'staging', 'e2e', 'approve', 'prod', 'rollback', 'end'] },
      ],
    },
  },
  {
    id: 'loan-approval',
    name: 'Loan Approval',
    description: 'Bank loan application process · 5,120 applications',
    graph: {
      nodes: [
        { id: 'start', label: 'Application', count: '5.120', type: 'start', layer: 0, col: 0 },
        { id: 'kyc', label: 'KYC check', count: '5.120', type: 'activity', layer: 1, col: 0 },
        { id: 'credit', label: 'Credit score', count: '4.890', type: 'activity', layer: 2, col: 0 },
        { id: 'manual', label: 'Manual review', count: '1.240', type: 'activity', layer: 3, col: 0 },
        { id: 'auto-ok', label: 'Auto approved', count: '3.650', type: 'activity', layer: 3, col: 1 },
        { id: 'collateral', label: 'Collateral check', count: '890', type: 'activity', layer: 4, col: 0 },
        { id: 'approved', label: 'Loan approved', count: '4.210', type: 'activity', layer: 4, col: 1 },
        { id: 'declined', label: 'Loan declined', count: '910', type: 'activity', layer: 5, col: 0 },
        { id: 'disburse', label: 'Disbursement', count: '4.210', type: 'activity', layer: 5, col: 1 },
        { id: 'end', label: 'Case closed', count: '5.120', type: 'end', layer: 6, col: 0 },
      ],
      edges: [
        { from: 'start', to: 'kyc', label: '5.120', weight: 5120 },
        { from: 'kyc', to: 'credit', label: '4.890', weight: 4890 },
        { from: 'kyc', to: 'declined', label: '230', weight: 230 },
        { from: 'credit', to: 'manual', label: '1.240', weight: 1240 },
        { from: 'credit', to: 'auto-ok', label: '3.650', weight: 3650 },
        { from: 'manual', to: 'collateral', label: '890', weight: 890 },
        { from: 'manual', to: 'approved', label: '350', weight: 350 },
        { from: 'manual', to: 'declined', label: '0', weight: 50 },
        { from: 'auto-ok', to: 'approved', label: '3.650', weight: 3650 },
        { from: 'collateral', to: 'approved', label: '760', weight: 760 },
        { from: 'collateral', to: 'declined', label: '130', weight: 130 },
        { from: 'approved', to: 'disburse', label: '4.210', weight: 4210 },
        { from: 'declined', to: 'end', label: '910', weight: 910 },
        { from: 'disburse', to: 'end', label: '4.210', weight: 4210 },
      ],
      traces: [
        { name: 'Auto-approved fast path', nodes: ['start', 'kyc', 'credit', 'auto-ok', 'approved', 'disburse', 'end'] },
        { name: 'Manual review → approved', nodes: ['start', 'kyc', 'credit', 'manual', 'approved', 'disburse', 'end'] },
        { name: 'Collateral required', nodes: ['start', 'kyc', 'credit', 'manual', 'collateral', 'approved', 'disburse', 'end'] },
        { name: 'Collateral insufficient', nodes: ['start', 'kyc', 'credit', 'manual', 'collateral', 'declined', 'end'] },
        { name: 'KYC failure → declined', nodes: ['start', 'kyc', 'declined', 'end'] },
        { name: 'Manual review → declined', nodes: ['start', 'kyc', 'credit', 'manual', 'declined', 'end'] },
      ],
    },
  },
  {
    id: 'support-ticket',
    name: 'Support Ticket',
    description: 'Customer support ticket lifecycle · 8,750 tickets',
    graph: {
      nodes: [
        { id: 'start', label: 'Ticket opened', count: '8.750', type: 'start', layer: 0, col: 0 },
        { id: 'triage', label: 'Triage', count: '8.750', type: 'activity', layer: 1, col: 0 },
        { id: 'l1', label: 'L1 support', count: '6.300', type: 'activity', layer: 2, col: 0 },
        { id: 'l2', label: 'L2 escalation', count: '2.450', type: 'activity', layer: 2, col: 1 },
        { id: 'resolved', label: 'Resolved', count: '5.890', type: 'activity', layer: 3, col: 0 },
        { id: 'l3', label: 'L3 engineering', count: '1.120', type: 'activity', layer: 3, col: 1 },
        { id: 'reopen', label: 'Reopened', count: '940', type: 'activity', layer: 4, col: 0 },
        { id: 'fix', label: 'Bug fix deployed', count: '870', type: 'activity', layer: 4, col: 1 },
        { id: 'csat', label: 'CSAT survey', count: '7.810', type: 'activity', layer: 5, col: 0 },
        { id: 'end', label: 'Ticket closed', count: '8.750', type: 'end', layer: 6, col: 0 },
      ],
      edges: [
        { from: 'start', to: 'triage', label: '8.750', weight: 8750 },
        { from: 'triage', to: 'l1', label: '6.300', weight: 6300 },
        { from: 'triage', to: 'l2', label: '2.450', weight: 2450 },
        { from: 'l1', to: 'resolved', label: '5.890', weight: 5890 },
        { from: 'l1', to: 'l2', label: '410', weight: 410 },
        { from: 'l2', to: 'resolved', label: '1.740', weight: 1740 },
        { from: 'l2', to: 'l3', label: '1.120', weight: 1120 },
        { from: 'resolved', to: 'reopen', label: '940', weight: 940 },
        { from: 'resolved', to: 'csat', label: '4.950', weight: 4950 },
        { from: 'l3', to: 'fix', label: '870', weight: 870 },
        { from: 'l3', to: 'resolved', label: '250', weight: 250 },
        { from: 'reopen', to: 'l1', label: '580', weight: 580 },
        { from: 'reopen', to: 'l2', label: '360', weight: 360 },
        { from: 'fix', to: 'resolved', label: '870', weight: 870 },
        { from: 'csat', to: 'end', label: '7.810', weight: 7810 },
        { from: 'resolved', to: 'end', label: '2.860', weight: 2860 },
      ],
      traces: [
        { name: 'L1 quick resolve', nodes: ['start', 'triage', 'l1', 'resolved', 'csat', 'end'] },
        { name: 'L2 escalation → resolved', nodes: ['start', 'triage', 'l2', 'resolved', 'csat', 'end'] },
        { name: 'Full escalation to L3', nodes: ['start', 'triage', 'l1', 'l2', 'l3', 'fix', 'resolved', 'csat', 'end'] },
        { name: 'Resolved then reopened', nodes: ['start', 'triage', 'l1', 'resolved', 'reopen', 'l1', 'resolved', 'csat', 'end'] },
        { name: 'L3 → closed no survey', nodes: ['start', 'triage', 'l2', 'l3', 'resolved', 'end'] },
        { name: 'Reopen escalates to L3', nodes: ['start', 'triage', 'l1', 'resolved', 'reopen', 'l2', 'l3', 'fix', 'resolved', 'csat', 'end'] },
      ],
    },
  },
  {
    id: 'recipe',
    name: 'Pizza Order (Restaurant)',
    description: 'Restaurant order from entry to table · 620 orders',
    graph: {
      nodes: [
        { id: 'start', label: 'Guest seated', count: '620', type: 'start', layer: 0, col: 0 },
        { id: 'order', label: 'Order taken', count: '620', type: 'activity', layer: 1, col: 0 },
        { id: 'kitchen', label: 'In kitchen', count: '620', type: 'activity', layer: 2, col: 0 },
        { id: 'modify', label: 'Order modified', count: '88', type: 'activity', layer: 2, col: 1 },
        { id: 'ready', label: 'Food ready', count: '620', type: 'activity', layer: 3, col: 0 },
        { id: 'serve', label: 'Served', count: '620', type: 'activity', layer: 4, col: 0 },
        { id: 'complaint', label: 'Complaint', count: '34', type: 'activity', layer: 5, col: 0 },
        { id: 'bill', label: 'Bill requested', count: '620', type: 'activity', layer: 5, col: 1 },
        { id: 'end', label: 'Guest leaves', count: '620', type: 'end', layer: 6, col: 0 },
      ],
      edges: [
        { from: 'start', to: 'order', label: '620', weight: 620 },
        { from: 'order', to: 'kitchen', label: '620', weight: 620 },
        { from: 'kitchen', to: 'modify', label: '88', weight: 88 },
        { from: 'modify', to: 'kitchen', label: '88', weight: 88 },
        { from: 'kitchen', to: 'ready', label: '620', weight: 620 },
        { from: 'ready', to: 'serve', label: '620', weight: 620 },
        { from: 'serve', to: 'complaint', label: '34', weight: 34 },
        { from: 'serve', to: 'bill', label: '586', weight: 586 },
        { from: 'complaint', to: 'kitchen', label: '24', weight: 24 },
        { from: 'complaint', to: 'bill', label: '10', weight: 10 },
        { from: 'bill', to: 'end', label: '620', weight: 620 },
      ],
      traces: [
        { name: 'Smooth dinner', nodes: ['start', 'order', 'kitchen', 'ready', 'serve', 'bill', 'end'] },
        { name: 'Order modified once', nodes: ['start', 'order', 'kitchen', 'modify', 'kitchen', 'ready', 'serve', 'bill', 'end'] },
        { name: 'Complaint handled', nodes: ['start', 'order', 'kitchen', 'ready', 'serve', 'complaint', 'bill', 'end'] },
        { name: 'Complaint → remake', nodes: ['start', 'order', 'kitchen', 'ready', 'serve', 'complaint', 'kitchen', 'ready', 'serve', 'bill', 'end'] },
        { name: 'Multiple modifications', nodes: ['start', 'order', 'kitchen', 'modify', 'kitchen', 'modify', 'kitchen', 'ready', 'serve', 'bill', 'end'] },
      ],
    },
  },
]

export function getProcessModelLibraryEntry(id: string): ProcessModelLibraryEntry | undefined {
  return processModelLibrary.find((e) => e.id === id)
}
